<div class="chat-window flex flex-column">
  <div class="chat-window-header flex justify-content-between align-items-end">
    <div>Live Support</div>
    <div class="chat-window-header-action flex gap-3 align-items-center">
      @if (isSoundNotificationEnabled) {
        <svg-icon
          class="chat-sound-notification"
          key="notificationOn"
          size="lg"
          (click)="toggleSoundNotification()"
          title="Sound notifications enabled. Click to disable."></svg-icon>
      } @else {
        <svg-icon
          class="chat-sound-notification"
          key="notificationOff"
          size="lg"
          (click)="toggleSoundNotification()"
          title="Sound notifications disabled. Click to enable."></svg-icon>
      }
      <div class="action" (click)="hideChatWindow()">
        <i class="pi pi-minus"></i>
      </div>
    </div>
  </div>
  <div class="chat-window-action">
    @switch (currentStep$ | async) {
      @case ('REPORT') {
        <div>
          <div (click)="goNextStep()" class="back-step gap-2">
            <div><i class="pi pi-chevron-left"></i></div>
            <div>Report an issue</div>
          </div>
        </div>
      }
      @case ('LIVE') {
        <div>
          <div (click)="goNextStep()" class="back-step gap-2">
            <div><i class="pi pi-chevron-left"></i></div>
            <div>Connect with an agent</div>
          </div>
        </div>
      }
      @default {
        <div></div>
      }
    }
  </div>

  <div class="chat-window-body">
    @switch (currentStep$ | async) {
      @case ('REPORT') {
        <div class="h-full">
          <app-chat-report></app-chat-report>
        </div>
      }
      @case ('LIVE') {
        <div class="h-full">
          <app-chat-live-support
            (emitTotalUnread)="setTotalUnread($event)"></app-chat-live-support>
        </div>
      }
      @case ('SENT') {
        <div
          class="default-template flex flex-column align-items-center justify-content-center gap-2 mb-5">
          <div class="flex flex-column align-items-center gap-2 mb-2">
            <div>
              <svg-icon
                class="icon-info"
                key="sentSupport"
                size="xxl"></svg-icon>
            </div>
            <div>Your issue was successfully sent!</div>
          </div>
          <div
            class="step-button step-button--secondary"
            (click)="showForm('REPORT')">
            Report an issue
          </div>
          <div
            class="step-button step-button--secondary"
            (click)="showForm('LIVE')">
            Connect with an agent
          </div>
        </div>
      }
      @case ('SENT_AGENT') {
        <div
          class="default-template flex flex-column align-items-center justify-content-center gap-2 mb-5">
          <div class="flex flex-column align-items-center gap-2 mb-2">
            <div>
              <svg-icon
                class="icon-info"
                key="sentSupport"
                size="xxl"></svg-icon>
            </div>
            <div class="mb-2">Your message was successfully sent!</div>
            <div class="text-center">
              The support team will respond to you as soon as possible.
            </div>
          </div>
          <div class="step-button step-button--primary" (click)="goNextStep()">
            Close
          </div>
        </div>
      }
      @default {
        <div
          class="default-template flex flex-column align-items-center justify-content-center gap-2 mb-5">
          <div class="flex flex-column align-items-center gap-2 mb-2">
            <div>
              <svg-icon
                class="icon-info"
                key="liveSupport"
                size="xxl"></svg-icon>
            </div>
            <div>Please choose an action</div>
          </div>
          <div
            class="step-button step-button--secondary"
            (click)="showForm('REPORT')">
            Report an issue
          </div>
          @if (totalUnreadMsg > 0) {
            <div
              class="step-button step-button--secondary"
              (click)="showForm('LIVE')"
              pBadge
              severity="danger"
              [value]="totalUnreadMsg.toString()">
              Connect with an agent
            </div>
          } @else {
            <div
              class="step-button step-button--secondary"
              (click)="showForm('LIVE')">
              Connect with an agent
            </div>
          }
        </div>
      }
    }
  </div>

  <app-confirmation-overlay
    [confirmMessage]="'Are you sure to close the chat?'"
    [primaryText]="'Yes, close the chat'"
    [secondaryText]="'Back to chat'"
    (confirm)="closeChatWindow()"
    #confirmationOverlay>
  </app-confirmation-overlay>

  <app-loading
    [isLoading]="(isLoading$ | async)!"
    [isIconShow]="true"
    [size]="'50px'"></app-loading>
</div>
<div class="overlay" (click)="hideChatWindow()"></div>
